import React, { lazy } from 'react';

// project imports
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';
import AuthGuard from 'utils/route-guard/AuthGuard';

// Direct imports for restored features
import SwayamSuchakList from 'views/application/pmp-swayamsuchak/SwayamSuchakList';
import Report from 'views/application/pmp-swayamsuchak/report/Report';
import Sanghik from 'views/application/pmp-sanghik/Sanghik';
import Sanghikahawal from 'views/application/pmp-sanghik/Sanghikahawal';
import EditGeoTreeReport from 'views/application/pmp-geo-structure/EditGeoTreeReport';

// PMP Routes - User Management
const AddPMPUser = Loadable(lazy(() => import('views/application/pmp-users/add-pmp-user')));
const PmpUsersTableView = Loadable(lazy(() => import('views/application/pmp-users/pmpUsersTableView')));
const UnapprovedUsers = Loadable(lazy(() => import('views/application/pmp-users/UnapprovedUsers')));

// PMP Routes - Geographic Structure
const GeoTreeReport = Loadable(lazy(() => import('views/application/pmp-geo-structure/GeoTreeReport')));

// PMP Routes - Dashboard
const DashboardDefault = Loadable(lazy(() => import('views/application/pmp-dashboard/PMPDashboard')));

// PMP Routes - Seva Vasti
const PmpSevaVastiSuchi = Loadable(lazy(() => import('views/application/pmp-seva-vasti/pmp-seva-vast-suchi')));

// PMP Routes - Sankalp
const PmpMultiSankalpAdd = Loadable(lazy(() => import('views/application/pmp-sankalp/add-multisankalp')));
const SankalpCards = Loadable(lazy(() => import('views/application/pmp-sankalp/SankalpCards')));
const SankalpWrapper = Loadable(lazy(() => import('views/application/pmp-sankalp/SankalpWrapper')));
const SankalpDetailsTab = Loadable(lazy(() => import('views/application/pmp-sankalp/SankalpDetailsTab')));

// PMP Routes - Sadyasthiti
const Sadyasthiti = Loadable(lazy(() => import('views/application/pmp-sadyasthiti/Sadyasthiti')));
const SadyasthitiSuchi = Loadable(lazy(() => import('views/application/pmp-sadyasthiti/SadyasthitiSuchi')));
const SadyasthitiAhawal = Loadable(lazy(() => import('views/application/pmp-sadyasthiti/SadyasthitiAhawal')));
const SadyasthitiActiveSuchi = Loadable(lazy(() => import('views/application/pmp-sadyasthiti/SadyasthitiActiveSuchi')));

// PMP Routes - Utsav Sankhya Nondani
const UtsavMakarSankrant = Loadable(lazy(() => import('views/application/pmp-utsav-sankhya-nondani/UtsavMakarSankrant')));
const UtsavVarshPratipada = Loadable(lazy(() => import('views/application/pmp-utsav-sankhya-nondani/UtsavVarshPratipada')));
const UtsavHindusamrajyaDin = Loadable(lazy(() => import('views/application/pmp-utsav-sankhya-nondani/UtsavHindusamrajyaDin')));
const UtsavGurupujan = Loadable(lazy(() => import('views/application/pmp-utsav-sankhya-nondani/UtsavGurupujan')));
const UtsavRakshabandhan = Loadable(lazy(() => import('views/application/pmp-utsav-sankhya-nondani/UtsavRakshabandhan')));
const UtsavVijayadasami = Loadable(lazy(() => import('views/application/pmp-utsav-sankhya-nondani/UtsavVijayadasami')));

// PMP Routes - Utsav Vrutta
const MakarSankrantVrutta = Loadable(lazy(() => import('views/application/pmp-utsav-vrutta/MakarsankrantUtsavVrutta')));
const VarshpratipadaVrutta = Loadable(lazy(() => import('views/application/pmp-utsav-vrutta/VarshpratipadaUtsavVrutta')));
const HindusamrajyaDinUtsavVrutta = Loadable(lazy(() => import('views/application/pmp-utsav-vrutta/HindusamrajyaDinUtsavVrutta')));
const GurupujanUtsavVrutta = Loadable(lazy(() => import('views/application/pmp-utsav-vrutta/GurupujanUtsavVrutta')));
const RakshabandhanUtsavVrutta = Loadable(lazy(() => import('views/application/pmp-utsav-vrutta/RakshabandhanUtsavVrutta')));
const VijayadashamiUtsavVrutta = Loadable(lazy(() => import('views/application/pmp-utsav-vrutta/VijayadashamiUtsavVrutta')));

// PMP Routes - About
const AboutPmpApp = Loadable(lazy(() => import('views/pmp_misc/AboutPMP')));

// PMP Routes - Ahawal (restored feature - menu items commented)
const AhawalList = Loadable(lazy(() => import('views/application/pmp-ahawal/AhawalList')));

// PMP Routes - Lokjagaran Abhiyan (restored feature - menu items commented)
const LABhaugolikVrutta = Loadable(lazy(() => import('views/application/pmp-lokjagaran-abhiyan/BhaugolikVrutta/BhaugolikVruttaContainer')));
const LASamajikVrutta = Loadable(lazy(() => import('views/application/pmp-lokjagaran-abhiyan/SamajikVrutta/SamajikVruttaContainer')));
const LASahayogiSansthMahiti = Loadable(
    lazy(() => import('views/application/pmp-lokjagaran-abhiyan/SahayogiSansthaMahitiSankalan/SahayogiSansthaMahitiContainer'))
);
const LAVividhKshetraVrutta = Loadable(
    lazy(() => import('views/application/pmp-lokjagaran-abhiyan/VividhKshetraVrutta/VividhKshetraVruttaContainer'))
);

// PMP Routes - Ramlalla Pratishthapana Abhiyan (restored feature - menu items commented)
const PmpRpsaAbhiyanVrutta = Loadable(lazy(() => import('views/application/pmp-ramlalla-pratisthapana-abhiyan/abhiyanVrutta')));
const PmpRpsaKaryakramVrutta = Loadable(lazy(() => import('views/application/pmp-ramlalla-pratisthapana-abhiyan/karyakramVrutta')));
const PmpRpsaKaryakartaSuchi = Loadable(lazy(() => import('views/application/pmp-ramlalla-pratisthapana-abhiyan/karyakartaSuchi')));
const PmpRpsaAnukulVyaktiSuchi = Loadable(lazy(() => import('views/application/pmp-ramlalla-pratisthapana-abhiyan/anukulVyaktiSuchi')));
const PmpRpsaAbhiyanGoshwara = Loadable(lazy(() => import('views/application/pmp-ramlalla-pratisthapana-abhiyan/abhiyanGoshwara')));
const PmpRpsaKaryakramGoshwara = Loadable(lazy(() => import('views/application/pmp-ramlalla-pratisthapana-abhiyan/karyakramGoshwara')));

// ===========================|| MAIN ROUTING ||=========================== //

const MainRoutes = {
    path: '/',
    element: (
        <AuthGuard>
            <MainLayout />
        </AuthGuard>
    ),
    children: [
        {
            path: '/dashboard/default',
            element: <DashboardDefault />
        },
        {
            path: '/geo/tree',
            element: <GeoTreeReport />
        },
        {
            path: '/geo/tree/edit',
            element: <EditGeoTreeReport />
        },
        {
            path: '/user/add',
            element: <AddPMPUser />
        },
        {
            path: '/user/list',
            element: <PmpUsersTableView />
        },
        {
            path: '/user/unapproved',
            element: <UnapprovedUsers />
        },
        {
            path: '/seva-vasti/add',
            element: <PmpSevaVastiSuchi />
        },
        {
            path: '/seva-vasti/list',
            element: <PmpSevaVastiSuchi />
        },
        {
            path: '/sankalp/addmultisankalp',
            element: <PmpMultiSankalpAdd />
        },
        {
            path: '/sankalp/list',
            element: <SankalpCards />
        },
        {
            path: '/sankalp/ahawal',
            element: <SankalpWrapper />
        },
        {
            path: '/sankalp/detailView/:sankalpId',
            element: <SankalpDetailsTab />
        },
        {
            path: '/sadyasthiti/view/:sankalpId',
            element: <Sadyasthiti />
        },
        {
            path: '/sadyashiti/list',
            element: <SadyasthitiSuchi />
        },
        {
            path: '/sadyashiti/ahawal',
            element: <SadyasthitiAhawal />
        },
        {
            path: '/sadyashiti/active-suchi',
            element: <SadyasthitiActiveSuchi />
        },
        // Ahawal routes (restored feature - menu items commented)
        {
            path: '/ahawal/list',
            element: <AhawalList />
        },
        // Swayamsuchak routes (restored feature - menu items commented)
        {
            path: '/swayamsuchak/list',
            element: <SwayamSuchakList />
        },
        {
            path: '/swayamsuchak/report',
            element: <Report />
        },
        // Sanghik routes (restored feature - menu items commented)
        {
            path: '/sanghik/add',
            element: <Sanghik />
        },
        {
            path: '/sanghik/ahawal',
            element: <Sanghikahawal />
        },
        // Lokjagaran Abhiyan routes (restored feature - menu items commented)
        {
            path: '/PMP-LJAV/bhaugolik-vrutta',
            element: <LABhaugolikVrutta />
        },
        {
            path: '/PMP-LJAV/samajik-vrutta',
            element: <LASamajikVrutta />
        },
        {
            path: '/PMP-LJAV/sahayogi-sansth-mahiti',
            element: <LASahayogiSansthMahiti />
        },
        {
            path: '/PMP-LJAV/vividh-kshetra-vrutta',
            element: <LAVividhKshetraVrutta />
        },
        // Ramlalla Pratishthapana Abhiyan routes (restored feature - menu items commented)
        {
            path: '/PMP-RPSA/abhiyan-vrutta',
            element: <PmpRpsaAbhiyanVrutta />
        },
        {
            path: '/PMP-RPSA/karyakram-vrutta',
            element: <PmpRpsaKaryakramVrutta />
        },
        {
            path: '/PMP-RPSA/karyakarta-suchi',
            element: <PmpRpsaKaryakartaSuchi />
        },
        {
            path: '/PMP-RPSA/anukulVyakti-suchi',
            element: <PmpRpsaAnukulVyaktiSuchi />
        },
        {
            path: '/PMP-RPSA/abhiyan-goshwara',
            element: <PmpRpsaAbhiyanGoshwara />
        },
        {
            path: '/PMP-RPSA/karyakram-goshwara',
            element: <PmpRpsaKaryakramGoshwara />
        },
        {
            path: '/utsav/makarsankrant-nondani',
            element: <UtsavMakarSankrant />
        },
        {
            path: '/utsav/varshpratipada-nondani',
            element: <UtsavVarshPratipada />
        },
        {
            path: '/utsav/hindusamrajyadin-nondani',
            element: <UtsavHindusamrajyaDin />
        },
        {
            path: '/utsav/gurupujan-nondani',
            element: <UtsavGurupujan />
        },
        {
            path: '/utsav/rakshabandhan-nondani',
            element: <UtsavRakshabandhan />
        },
        {
            path: '/utsav/vijayadashami-nondani',
            element: <UtsavVijayadasami />
        },
        {
            path: '/utsav/makarsankrant-vrutta',
            element: <MakarSankrantVrutta />
        },
        {
            path: '/utsav/varshpratipada-vrutta',
            element: <VarshpratipadaVrutta />
        },
        {
            path: '/utsav/hindusamrajyadin-vrutta',
            element: <HindusamrajyaDinUtsavVrutta />
        },
        {
            path: '/utsav/gurupujan-vrutta',
            element: <GurupujanUtsavVrutta />
        },
        {
            path: '/utsav/rakshabandhan-vrutta',
            element: <RakshabandhanUtsavVrutta />
        },
        {
            path: '/utsav/vijayadashami-vrutta',
            element: <VijayadashamiUtsavVrutta />
        },
        {
            path: '/about',
            element: <AboutPmpApp />
        }
    ]
};

export default MainRoutes;
